import React from "react";
import { Link } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from "../Header/Footer";

const ContactUs = () => {
  const bgImage = "/images/gallery/matri.jpg"; // ✅ Background image path

  const containerStyle = {
    backgroundImage: `url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",        // Set background width
    height: "125vh",      // Full screen height (you can change to '600px' etc.)
    padding: "30px",
    color: "#fff",
    fontFamily: "'Segoe UI', sans-serif",
    display: "flex",
    justifyContent: "flex-end", // Align card to right side
    alignItems: "center",       // Center vertically
  };

  const cardStyle = {
    background: "rgba(0,0,0,0.65)",
    padding: "20px",
    borderRadius: "12px",
    maxWidth: "500px",
    height:"auto",
    boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
  };

  const bannerStyle = {
    backgroundColor: "rgba(0,0,0,0.7)",
    padding: "15px",
    borderRadius: "10px",
    textAlign: "center",
    fontSize: "2rem",
    fontWeight: "bold",
    color: "#d00d0dff",
    marginBottom: "20px",
  };

  const headingStyle = {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "1.8rem",
    fontWeight: "bold",
    borderBottom: "2px solid #ac0d0dff",
    paddingBottom: "10px",
  };

  const sectionStyle = {
    marginBottom: "20px",
    padding: "10px 0",
    borderBottom: "1px dashed #930606ff",
  };

  const titleStyle = {
    fontSize: "1.3rem",
    fontWeight: "bold",
    color: "#fe5757ff",
    marginBottom: "5px",
  };

  const textStyle = {
    margin: "2px 0",
  };

  return (
    <div>
      <Header/>
    <div style={containerStyle}>
      <div style={cardStyle}>
        {/* Banner Heading */}
        <div style={bannerStyle}>💍 Bhantham Matrimony 💍</div>

        <h1 style={headingStyle}>📞 Contact Us</h1>

        {/* Headquarters */}
        <div style={sectionStyle}>
          <div style={titleStyle}>🏢 Headquarters</div>
          <p style={textStyle}>523 கவிபாரதி நகர்</p>
          <p style={textStyle}>பீச் ரோடு ஜங்சன், கோட்டார் அஞ்சல் -629002</p>
          <p style={textStyle}>கன்னியாகுமரி மாவட்டம்</p>
        </div>

        {/* Global Offices */}
        <div style={sectionStyle}>
          <div style={titleStyle}>🌏 Global Offices</div>
          <p style={textStyle}><strong>SANKARANARAYANAN</strong></p>
          <p style={textStyle}>📞 9790221299</p>
          <p style={textStyle}>📧 dsankarrjpm@gmail.com</p>
          <p style={textStyle}>
            <a href="#" style={{ color: "#00d2d3" }}>Customer Care</a>
          </p>

          <hr style={{ border: "1px dashed #777" }} />

          <p style={textStyle}><strong>SEENIMEERAN</strong></p>
          <p style={textStyle}>📞 8939336125</p>
          <p style={textStyle}>📧 luckytravels09@gmail.com</p>
          <p style={textStyle}>
            <a href="#" style={{ color: "#00d2d3" }}>Customer Care</a>
          </p>
        </div>

        {/* Quick Links */}
        <div style={sectionStyle}>
          <div style={titleStyle}>🔗 Quick Links</div>
          <p style={textStyle}>
          <Link style={{ color: "#00d2d3" }} to='/AboutUs'>About Us</Link></p>
          <p style={textStyle}><a href="#" style={{ color: "#00d2d3" }}>Search</a></p>
          <p style={textStyle}><Link style={{ color: "#00d2d3" }} to='/PrivacyPolicy'>Privacy Policy</Link></p>
          <p style={textStyle}><Link style={{ color: "#00d2d3" }} to='/Contactus'>Contact Us</Link></p>
        </div>
      </div>
    </div>
    <Footer/>
    </div>
  );
};

export default ContactUs;
